import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { css } from '@emotion/react';
import { Box } from '@mui/material';

import { Text } from '~/components/ui/text';

type DownloadQRModalContentLayoutProps = {
  isLoading: boolean;
};

export default function DownloadQRModalContentLayout({
  isLoading,
  children,
}: PropsWithChildren<DownloadQRModalContentLayoutProps>) {
  const { t } = useTranslation();

  const styles = useStyles();

  return (
    <Box sx={styles.content} className={isLoading ? 'is-loading' : undefined}>
      <Text variant="h2">{t('downloadModal:title')}</Text>
      <Box sx={styles.imgFormatsWrapper}>{children}</Box>
    </Box>
  );
}

function useStyles() {
  return {
    content: css`
      display: flex;
      flex-direction: column;
      width: 100%;

      &.is-loading {
        pointer-events: none;
        opacity: 0.5;
      },
    `,
    imgFormatsWrapper: css`
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 24px;
    `,
  };
}
